import React, { useEffect, useState } from 'react';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
  getDashboardLink,
} from '../../features/app/appSlice';
import { getDocumentId } from '../../features/dashboard/dashboardSlice';
import { getApplicationClaim } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const ApprovalSubmitted = () => {
  const dashboardLink = useSelector(getDashboardLink);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const [claimData, setClaimData] = useState({});
  const documentId = useSelector(getDocumentId);

  useTitle(
    'dashboardHub.ApprovalSubmitted.s5',
    'Approval submitted - OZEV Electric Vehicle Chargepoint Grants - GOV.UK'
  );

  const handleButton = () => {
    window.location.assign(dashboardLink);
  };

  useEffect(() => {
    if (dashboardLink) {
      getApplicationClaim({ id: documentId }).then((response) => {
        const { data } = response;
        setClaimData(data);
      });
    }
  }, [documentId, dashboardLink]);

  const pageModel = (
    <div>
      <div className="govuk-panel govuk-panel--confirmation">
        <h1 className="govuk-panel__title">
          {copyProvider.getCopy(
            'dashboardHub.ApprovalSubmitted.s1',
            'Approval submitted'
          )}
        </h1>
        <div className="govuk-panel__body">
          {copyProvider.getCopy(
            'dashboardHub.ApprovalSubmitted.s2',
            'Your reference number'
          )}
          <br />
          <strong>{claimData.claim_id}</strong>
        </div>
      </div>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'dashboardHub.ApprovalSubmitted.s3',
          'We will review the details your installer submitted and process this claim.'
        )}
      </p>

      <Button
        className="govuk-button govuk-!-margin-top-4"
        onClick={handleButton}
      >
        {copyProvider.getCopy(
          'dashboardHub.ApprovalSubmitted.s4',
          'Manage your applications'
        )}
      </Button>
    </div>
  );
  return pageModel;
};

export default ApprovalSubmitted;
